import {
    FETCH_TASKS_REQUEST,
    FETCH_TASKS_SUCCESS,
    FETCH_TASKS_FAIL,
    CREATE_TASK_REQUEST,
    CREATE_TASK_SUCCESS,
    CREATE_TASK_FAIL,
    FETCH_TASK_REQUEST,
    FETCH_TASK_SUCCESS,
    FETCH_TASK_FAIL,
    UPDATE_TASK_REQUEST,
    UPDATE_TASK_SUCCESS,
    UPDATE_TASK_FAIL,
    DELETE_TASK_REQUEST,
    DELETE_TASK_SUCCESS,
    DELETE_TASK_FAIL,
    TASK_CREATE_RESET,
  } from '../constants/taskConstants';
  
  export const taskListReducer = (state = { tasks: [] }, action) => {
    switch (action.type) {
      case FETCH_TASKS_REQUEST:
        return { ...state, loading: true }; // Preserve existing tasks while loading
      case FETCH_TASKS_SUCCESS:
        return { loading: false, tasks: action.payload };
      case FETCH_TASKS_FAIL:
        return { loading: false, error: action.payload, tasks: state.tasks };
      case DELETE_TASK_SUCCESS:
        return {
          ...state,
          tasks: state.tasks.filter((task) => String(task._id) !== String(action.payload)),
        };
      default:
        return state;
    }
  };
  
  export const taskCreateReducer = (state = {}, action) => {
    switch (action.type) {
      case CREATE_TASK_REQUEST:
        return { loading: true };
      case CREATE_TASK_SUCCESS:
        return { loading: false, success: true, task: action.payload };
      case CREATE_TASK_FAIL:
        return { loading: false, error: action.payload };
      case TASK_CREATE_RESET:
        return {};
      default:
        return state;
    }
  };
  
  export const taskDetailsReducer = (state = { task: {} }, action) => {
    switch (action.type) {
      case FETCH_TASK_REQUEST:
        return { ...state, loading: true };
      case FETCH_TASK_SUCCESS:
        return { loading: false, task: action.payload };
      case FETCH_TASK_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const taskUpdateReducer = (state = { task: {} }, action) => {
    switch (action.type) {
      case UPDATE_TASK_REQUEST:
        return { loading: true };
      case UPDATE_TASK_SUCCESS:
        return { loading: false, success: true, task: action.payload };
      case UPDATE_TASK_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const taskDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case DELETE_TASK_REQUEST:
        return { loading: true };
      case DELETE_TASK_SUCCESS:
        return { loading: false, success: true };
      case DELETE_TASK_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };